export enum Auth0ConnectionStrategy {
    AUTH0 = 'auth0',
    OKTA = 'okta',
    GOOGLE = 'google-apps',
    AZUREAD = 'waad',
}
